import {nSuccessFunc, nWarn} from '../../../../utils/notice'
import errorHandler, {loge} from '../../../../utils/errorHandler'

const diDingPostOrPatchMixin = {
  methods: {
    initData () { // 必须为同步的方法
      const data = this.data
      this.initValidateMessage()
      this.keyMappingEntities.forEach(([, {init}]) => {
        init && init(data)
      })
      this.data = data
    },
    beforeTheDataIsPost (data) {
      this.keyMappingEntities.forEach(([, {beforeDataIsPost}]) => {
        beforeDataIsPost && beforeDataIsPost(data)
      })
    },
    fetchDetail () {
      const {data} = this
      this.keyMappingEntities.forEach(([, {fetchDetail, onDetailLoaded}]) => {
        fetchDetail && fetchDetail()
          .then(list => void onDetailLoaded(data, list))
      })
    },
    onChange (key, value) {
      const mapping = this.keyMappingOriginal[key]
      this.handleValidate(value, key)
      mapping.onSelected && mapping.onSelected(value, this.data)
    },
    patchData (data, onSuccess) {
      return this.postOrPatchData('patch', data, onSuccess)
    },
    postData (data, onSuccess) {
      return this.postOrPatchData('post', data, onSuccess)
    },
    async beforePostDataIsGenerate (data) {
      if (this.subConfig.beforePostDataIsGenerate) {
        return this.subConfig.beforePostDataIsGenerate(data, {
          vm: this
        })
      }
    },
    postOrPatchData (type, data, onSuccess) {
      if (!this.validateBeforePost(data)) {
        nWarn('部分项不合要求')
        return
      }
      this.beforePostDataIsGenerate(data)
        .then(() => {
          data = {...data}
          this.beforeTheDataIsPost(data)
          Object.keys(data).forEach(it => {
            if (it.startsWith('_')) {
              delete data[it]
            }
          })
          this.config[type](data)
            .then(nSuccessFunc(type === 'post' ? '添加成功' : '修改成功'))
            .then(onSuccess)
            .catch(errorHandler('请求失败'))
        })
        .catch(loge)
    }
  }
}

export default diDingPostOrPatchMixin
export {
  diDingPostOrPatchMixin
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/pages/di-ding-post-or-patch-mixin.js